import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../../context/ThemeContext';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

const RevenueChart = () => {
  const { isDarkMode } = useTheme();
  const data = [
    { month: 'Ene', direct: 1200, indirect: 800, team: 400 },
    { month: 'Feb', direct: 1900, indirect: 1200, team: 600 },
    { month: 'Mar', direct: 1500, indirect: 1000, team: 500 },
    { month: 'Abr', direct: 2200, indirect: 1500, team: 800 },
    { month: 'May', direct: 1800, indirect: 1300, team: 700 },
    { month: 'Jun', direct: 2500, indirect: 1800, team: 900 }
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} p-4 rounded-lg shadow-lg border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
          <p className={`font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>{label}</p>
          {payload.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {entry.name}: ${entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className={`${isDarkMode ? 'bg-gray-800/80' : 'bg-white/80'} backdrop-blur-sm rounded-3xl p-6 border ${isDarkMode ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-sm`}
    >
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>Comisiones por Tipo</h3>
          <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Evolución mensual de tus ganancias</p>
        </div>
        <div className="flex space-x-4">
          <button className={`px-3 py-1 text-sm ${isDarkMode ? 'bg-orange-900/50 text-orange-400' : 'bg-orange-50 text-orange-600'} rounded-lg`}>
            Mensual
          </button>
          <button className={`px-3 py-1 text-sm ${isDarkMode ? 'text-gray-500' : 'text-gray-500'} rounded-lg`}>
            Anual
          </button>
        </div>
      </div>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
            <XAxis
              dataKey="month"
              axisLine={false}
              tickLine={false}
              tick={{ fill: isDarkMode ? '#9CA3AF' : '#6B7280', fontSize: 12 }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: isDarkMode ? '#9CA3AF' : '#6B7280', fontSize: 12 }}
              tickFormatter={(value) => `$${value}`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Area 
              type="monotone" 
              dataKey="direct" 
              stackId="1"
              stroke="#3B82F6" 
              fill="#3B82F6" 
              fillOpacity={0.2}
              name="Directas"
            />
            <Area 
              type="monotone" 
              dataKey="indirect" 
              stackId="1"
              stroke="#10B981" 
              fill="#10B981" 
              fillOpacity={0.2}
              name="Indirectas"
            />
            <Area 
              type="monotone" 
              dataKey="team" 
              stackId="1"
              stroke="#8B5CF6" 
              fill="#8B5CF6" 
              fillOpacity={0.2}
              name="Equipo"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </motion.div>
  );
};

export default RevenueChart;